<template>
  <div class="overlay-buttons w-100 d-flex justify-content-center">
    <div class="d-flex justify-content-between">
      <div>
        <ButtonIconOnly :title="tr('javascript.TX_VIEW')"
                        icon-name="eye"
                        class="m-2 text-center"
                        :size="BootstrapVariant.SMALL"
                        :variant="BootstrapVariant.SECONDARY"
                        @click="onShow">
        </ButtonIconOnly>
        <ButtonIconOnly :title="tr('javascript.TX_DELETE_FILE')"
                        icon-name="bin"
                        class="m-2 text-center"
                        :size="BootstrapVariant.SMALL"
                        :variant="BootstrapVariant.SECONDARY"
                        @click="onRemove">
        </ButtonIconOnly>
      </div>
    </div>
  </div>
</template>

<script>
  import { translator } from '~/zf/frontend/common/mixins';
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
  import ButtonIconOnly from '../layout/ButtonIconOnly.vue';

  /*
    [Vue migration] Developer Note
    This component has a twin version for both Vue 2 and Vue 3 projects.
    When making changes, remember to update and test both versions.
  */
  export default {
    name: 'ImageActionsOverlay',
    compatConfig: {
      MODE: 3,
    },
    components: {
      ButtonIconOnly,
    },
    mixins: [
      translator,
    ],
    emits: ['remove-image', 'show-image'],
    data() {
      return {
        BootstrapVariant,
      };
    },
    methods: {
      onRemove() {
        this.$emit('remove-image');
      },
      onShow() {
        this.$emit('show-image');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .overlay-buttons {
    background-color: rgb(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
  }
</style>
